import { useMutation, useQueryClient } from "@tanstack/react-query";

import { reviewKeys } from "@/application/query-keys/review-keys";
import { reviewFlowsRepository } from "@/infrastructure/repositories/review-flows-supabase-repository";
import type { ReviewFlowPatch } from "@/infrastructure/repositories/review-flows-supabase-repository";
import type { ReviewFlowRow } from "@/infrastructure/supabase/database.types";

/** Input for the update-flow mutation (a persisted patch targeting one flow). */
export interface ReviewFlowUpdateInput {
  flowId: string;
  patch: ReviewFlowPatch;
}

/** Edit flow content (can_write/admin — RLS enforces it server-side). */
export function useUpdateReviewFlow() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ flowId, patch }: ReviewFlowUpdateInput) =>
      reviewFlowsRepository.update(flowId, patch),
    onSuccess: (row: ReviewFlowRow) => {
      queryClient.setQueryData(reviewKeys.flow(row.flow_id), row);
    },
  });
}
